var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.2174C0 6.81306 7.00772 0 15.6522 0H34.9565C35.5328 0 36 0.454204 36 1.01449V33.9855C36 34.5458 35.5328 35 34.9565 35H1.04348C0.467181 35 0 34.5458 0 33.9855V15.2174Z",
    fill: "#3F0EF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2503 11.6667H20.4419V27.4324H15.2503V11.6667Z",
    fill: "url(#pattern0_3944_299)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76083 17.6577H13.9524V27.4324H8.76083V17.6577Z",
    fill: "url(#pattern1_3944_299)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7398 7.56757H26.9314V27.4324H21.7398V7.56757Z",
    fill: "url(#pattern2_3944_299)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3944_299",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3944_299",
    transform: "scale(0.1 0.0322581)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_3944_299",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3944_299",
    transform: "scale(0.1 0.0322581)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_3944_299",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_3944_299",
    transform: "scale(0.0909091 0.025641)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3944_299",
    width: 10,
    height: 31,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAfCAYAAADeKVyVAAAAQElEQVQ4je3UoRWAMBBEwUlIA/TfVtpAIuHygsQEgbxvd/SWiDiwWTRhrNCsfkEJEyZM+DNs6Nhx4X7t5Xk6zgGCvQwB1b7GQgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_3944_299",
    width: 11,
    height: 39,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAnCAYAAADZwrJrAAAAaUlEQVQ4je3VsQmAQBBE0X+LF4gFGNt/DRYg14EdGCsYKK5sJqKyF3s/fjDhBFXtgQ5QnovADCTDC9C8wGujAJUDWq18zN/bxAmtNQdLDqbgggv+Pf4DPnJwbTg4cTS8O/FkfzK43grSCXpTFW6/25foAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.1653d034b4a0b775bc0275cd561173fe.svg";
export { ForwardRef as ReactComponent };